// import enterpriseFtSalesList from '../components/salesData/enterpriseFtSalesList.vue'
// import viewEnterpriseFtSales from '../components/salesData/viewEnterpriseFtSales.vue'

export default [
    {
        path: 'salesData/enterpriseFtSalesList',
        component: resolve => require(['@/components/salesData/enterpriseFtSalesList'],resolve),
        name:"EnterpriseFtSalesList",
        meta:{
            // id:'637',
            node:'salesData',
            url:'enterpriseFtSalesList',
        }
    },
    {
        path: 'salesData/viewEnterpriseFtSales',
        component: resolve => require(['@/components/salesData/viewEnterpriseFtSales'],resolve),
        name:"ViewEnterpriseFtSales",
        meta:{
            // id:'637',
            node:'salesData',
            url:'viewEnterpriseFtSales',
        }
    },
    { 
        path: 'salesData/enterpriseQtSalesList', 
        component: resolve => require(['@/components/salesData/enterpriseQtSalesList'],resolve),
        name:'EnterpriseQtSalesList',
        meta:{
            // id:'845',
            node:'salesData',
            url:'enterpriseQtSalesList',
        }
    },
    { 
        path: 'salesData/viewEenterpriseQtSales', 
        component: resolve => require(['@/components/salesData/viewEenterpriseQtSales'],resolve),
        name:'ViewEnterpriseQtSales',
        meta:{
            // id:'846',
            node:'salesData',
            url:'viewEenterpriseQtSales',
        }
    },
    {
        path: 'salesData/enterpriseShopSalesList',
        component: resolve => require(['@/components/salesData/enterpriseShopSalesList'],resolve),
        name:"EnterpriseShopSalesList",
        meta:{
            // id:'639',
            node:'salesData',
            url:'enterpriseShopSalesList',
        }
    },
    {
        path: 'salesData/viewEnterpriseShopSales',
        component: resolve => require(['@/components/salesData/viewEnterpriseShopSales'],resolve),
        name:"ViewEnterpriseShopSales",
        meta:{
            // id:'639',
            node:'salesData',
            url:'viewEnterpriseShopSales',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/salesData.js